import { gql } from '__generated__';

export default gql(`
  query GetParticipants($project_id: ID!, $page: Int, $per_page: Int, $search: String, $events: [ID!], $locales: [Locale!], $mail_opt_ins: [ID!], $received_messages: [ID!], $will_receive_messages: [ID!]) {
    project(id: $project_id) {
      id
      events {
        total
      }
      participants(page: $page, per_page: $per_page, events: $events, search: $search, locales: $locales, mail_opt_ins: $mail_opt_ins, received_messages: $received_messages, will_receive_messages: $will_receive_messages) {
        data {
          id
          full_name
          email
          events_count
          active
        }
        current_page
        per_page
        has_more_pages
      }
    }
  }
`);
